var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_ADMIN } from 'components/constants';
import { Trans } from 'react-i18next';
import { adminCreateNewUserAction } from '../../../../redux/actions/admin/admin.actions';
export default function ViewAdminUsers() {
    var dispatch = useDispatch();
    var _a = useState({}), newUserFormFields = _a[0], setNewUserFormFields = _a[1];
    var labelInlineStyles = { width: '150px', display: 'inline-block', marginBottom: '15px' };
    var inputInlineStyles = { width: '250px', display: 'inline-block', height: '30px' };
    function onFieldChange(e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setNewUserFormFields(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    }
    function onSubmit(e) {
        e.preventDefault();
        dispatch(adminCreateNewUserAction(newUserFormFields));
    }
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_ADMIN }),
        React.createElement("div", { className: "mar-left-80 mar-top-80" },
            React.createElement("div", { style: { maxWidth: '75em', margin: 'auto', padding: '0 1em' } },
                React.createElement("h2", null, "Create new user"),
                React.createElement("form", { onSubmit: onSubmit },
                    [
                        { label: 'Username:', name: 'username', type: 'text' },
                        { label: 'Name:', name: 'name', type: 'text' },
                        { label: 'Email:', name: 'email', type: 'text' },
                        { label: 'Password:', name: 'password', type: 'password' }
                    ].map(function (_a) {
                        var label = _a.label, name = _a.name, type = _a.type;
                        return (React.createElement("div", { key: name },
                            React.createElement("label", { style: labelInlineStyles }, label),
                            React.createElement("input", { style: inputInlineStyles, onChange: onFieldChange, name: name, type: type })));
                    }),
                    React.createElement("div", null,
                        React.createElement("label", { style: labelInlineStyles }, "Role:"),
                        React.createElement("select", { name: "rank", onChange: onFieldChange, style: inputInlineStyles, value: newUserFormFields.rank || '' },
                            React.createElement("option", { value: "" }),
                            React.createElement("option", { value: "USER" }, "User"),
                            React.createElement("option", { value: "FACILITATOR" },
                                React.createElement(Trans, { i18nKey: "facilitator" })),
                            React.createElement("option", { value: "ADMIN" }, "Admin"))),
                    React.createElement("input", { className: "main-button", type: "submit", value: "Create user" }))))));
}
